module.exports = __webpack_public_path__ + "static/media/success2.c5b62248.gif";